import { forwardRef } from 'react';
import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from 'react-router-dom';

export interface LinkProps extends ReactRouterLinkProps {}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ to, href, ...rest }, ref) => {
  if (to instanceof URL) {
    to = { pathname: to.pathname, search: to.search };
  }
  return <ReactRouterLink to={to} ref={ref} {...rest} />;
});

export interface AnchorProps extends Omit<React.ComponentProps<'a'>, 'href'> {
  href: URL | string;
}

export const Anchor = forwardRef<HTMLAnchorElement, AnchorProps>(({ href, ...rest }, ref) => {
  if (href instanceof URL) {
    href = href.toString();
  }
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a href={href} ref={ref} {...rest} />;
});
